import { Swiper } from '@services';

class BaseSwiper extends HTMLElement {
  connectedCallback() {
    this.#initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy?.();
    }
  }

  #initSwiper() {
    try {
      this.swiper = new Swiper(this);
    } catch (error) {
      console.error('Error initializing Swiper:', error);
    }
  }
}

if (!customElements.get('base-swiper')) {
  customElements.define('base-swiper', BaseSwiper);
}

export { BaseSwiper as default };
